import { FlagIcon } from "react-flag-kit";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  getLangAll,
  getTicketTypes,
  postTicketTypes,
  pustTicketTypes,
  deleteTicketTypes,
} from "../../store/middleware";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";

import { Prices } from "./styles";

function NewTickets() {
  let { id } = useParams();
  let { state } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allLingos } = useSelector((state) => state.genericReducer);

  const [open, setOpen] = useState(false);
  const [type, setType] = useState({
    nameEnglish: "",
    nameSpanish: "",
    namePortuguese: "",
    nameFrench: "",
    active: false,
  });
  const [subTypes, setSubTypes] = useState([
    {
      nameEnglish: "",
      nameSpanish: "",
      namePortuguese: "",
      nameFrench: "",
      role: "select",
      lingoLanguageId: 0,
      active: false,
    },
  ]);

  const getData = () => {
    dispatch(getLangAll());
    if (id) {
      setType({
        nameEnglish: state?.data?.nameEnglish,
        nameSpanish: state?.data?.nameSpanish,
        namePortuguese: state?.data?.namePortuguese,
        nameFrench: state?.data?.nameFrench,
        active: state?.data?.active,
      });
      setSubTypes(state?.data?.ticketSubTypes);
    }
  };

  const addSubtype = (e) => {
    e.preventDefault();

    setSubTypes((state) => [
      ...state,
      {
        nameEnglish: "",
        nameSpanish: "",
        namePortuguese: "",
        nameFrench: "",
        role: "select",
        lingoLanguageId: 0,
        active: false,
      },
    ]);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setType((state) => ({ ...state, [name]: newValue }));
  };

  const handleChangeSubtype = (e, index) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setSubTypes((state) => state.map((item, i) => (i === index ? { ...item, [name]: newValue } : item)));
  };

  const handlePost = async () => {
    if (!id) {
      await dispatch(postTicketTypes("ticketTypes", type)).then(async (resp) => {
        for (let index = 0; index < subTypes.length; index++) {
          await dispatch(postTicketTypes("ticketSubTypes", subTypes[index], resp.id));
        }
        await dispatch(getTicketTypes());

        navigate(-1);
      });
    } else {
      dispatch(pustTicketTypes("ticketTypes", type, id)).then(async () => {
        for (let index = 0; index < subTypes.length; index++) {
          let newSubType = {
            nameEnglish: subTypes[index].nameEnglish,
            nameSpanish: subTypes[index].nameSpanish,
            namePortuguese: subTypes[index].namePortuguese,
            nameFrench: subTypes[index].nameFrench,
            role: subTypes[index].role,
            lingoLanguageId: subTypes[index].lingoLanguageId,
            active: subTypes[index].active,
          };

          if (!subTypes[index].id) {
            await dispatch(postTicketTypes("ticketSubTypes", newSubType, id));
          } else {
            await dispatch(pustTicketTypes("ticketSubTypes", newSubType, id, subTypes[index].id));
          }
        }

        await dispatch(getTicketTypes());
        navigate(-1);
      });
    }
  };

  const handleDeleteType = () => {
    dispatch(deleteTicketTypes("ticketTypes", id)).then(() => setOpen(false), navigate(-1));
  };

  const handleDeleteSubtype = (subId, index) => {
    dispatch(deleteTicketTypes("ticketSubTypes", id, subId));
    setSubTypes((state) => state.filter((_, i) => i !== index));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header t={t} title="Tickets" icon={<img src={Engrenagem} alt="Engrenagem" />} typeIcon="custom" />
        <div className="content">
          <Prices>
            <div className="bigBox teste">
              <h2>{!id ? "Add New Ticket" : type.nameEnglish}</h2>

              <div className="planInfo">
                <h3>Type</h3>

                <form className="formulario">
                  <div>
                    <label htmlFor="name">English</label>
                    <span>Required</span>
                  </div>
                  <input
                    placeholder="Enter ticket type"
                    name="nameEnglish"
                    value={type.nameEnglish}
                    onChange={handleChange}
                  />

                  <div>
                    <label htmlFor="gender">Português</label>
                    <span>Required</span>
                  </div>
                  <input
                    placeholder="Enter ticket type"
                    name="namePortuguese"
                    value={type.namePortuguese}
                    onChange={handleChange}
                    className="inputMobile"
                  />

                  <div>
                    <label htmlFor="gender">Español</label>
                    <span>Required</span>
                  </div>
                  <input
                    placeholder="Enter ticket type"
                    name="nameSpanish"
                    value={type.nameSpanish}
                    onChange={handleChange}
                    className="inputMobile"
                  />

                  <div>
                    <label htmlFor="gender">{t("FRENCH")}</label>
                    <span>Required</span>
                  </div>
                  <input
                    placeholder="Enter ticket type"
                    name="nameFrench"
                    value={type.nameFrench}
                    onChange={handleChange}
                    className="inputMobile"
                  />

                  <label htmlFor="active">Active?</label>
                  <div className="switchBox">
                    <div className="switch__container">
                      <input
                        id="switch-shadow"
                        className="switch switch--shadow2"
                        type="checkbox"
                        checked={type.active}
                        onChange={handleChange}
                        name="active"
                      />
                      <label htmlFor="switch-shadow">
                        <span>{type.active ? "Yes" : "No"}</span>
                      </label>
                    </div>
                  </div>

                  <div>
                    {id && (
                      <Button onClick={() => setOpen(true)} className="deleteType">
                        Delete type
                      </Button>
                    )}
                  </div>

                  <h3>Subtypes</h3>

                  {subTypes?.map((item, index) => (
                    <div key={index}>
                      <div>
                        <div>
                          <label htmlFor="name">English</label>
                          <span>Required</span>
                        </div>
                        <input
                          id={index}
                          name="nameEnglish"
                          value={item.nameEnglish}
                          placeholder="Enter subtype"
                          onChange={(e) => handleChangeSubtype(e, index)}
                        />

                        <div>
                          <label htmlFor="gender">Português</label>
                          <span>Required</span>
                        </div>
                        <input
                          id={index}
                          name="namePortuguese"
                          placeholder="Enter subtype"
                          value={item.namePortuguese}
                          onChange={(e) => handleChangeSubtype(e, index)}
                        />

                        <div>
                          <label htmlFor="gender">Español</label>
                          <span>Required</span>
                        </div>
                        <input
                          id={index}
                          name="nameSpanish"
                          value={item.nameSpanish}
                          placeholder="Enter subtype"
                          onChange={(e) => handleChangeSubtype(e, index)}
                        />

                        <div>
                          <label htmlFor="gender">{t("FRENCH")}</label>
                          <span>Required</span>
                        </div>
                        <input
                          id={index}
                          name="nameFrench"
                          placeholder="Enter subtype"
                          value={item.nameFrench}
                          onChange={(e) => handleChangeSubtype(e, index)}
                        />

                        <div className="linhaSelects">
                          <div>
                            <label htmlFor="role">Profile</label>
                            <span>Required</span>
                            <div>
                              <select
                                value={item.role}
                                onChange={(e) => handleChangeSubtype(e, index)}
                                name="role"
                                id={index}
                              >
                                <option value="">Select</option>
                                <option value="coordinator">{t("COORDINATOR")}</option>
                                <option value="customerService">{t("ITEM_CUSTOMER_SERVICE")}</option>
                                <option value="companyManager">{t("COMPANY_MANAGER")}</option>
                              </select>
                            </div>
                          </div>

                          <div>
                            <label htmlFor="language">Language</label>
                            <div>
                              <Select
                                name="lingoLanguageId"
                                className="input-lingo Select"
                                value={item.lingoLanguageId}
                                onChange={(e) => handleChangeSubtype(e, index)}
                              >
                                {allLingos?.map((lingo) => (
                                  <MenuItem key={lingo.id} value={lingo.id}>
                                    <FlagIcon code={lingo.flag} /> {lingo.language.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>

                        <label htmlFor="active">Active?</label>
                        <div className="switchBox">
                          <div className="switch__container">
                            <input
                              type="checkbox"
                              name="active"
                              checked={item.active}
                              id={`switch-shadow${index}`}
                              className="switch switch--shadow3"
                              onChange={(e) => handleChangeSubtype(e, index)}
                            />
                            <label htmlFor={`switch-shadow${index}`}>
                              <span>{item.active ? "Yes" : "No"}</span>
                            </label>
                          </div>
                        </div>

                        <hr />
                      </div>

                      <div>
                        {id && (
                          <Button onClick={() => handleDeleteSubtype(item.id, index)} className="deleteType">
                            Delete Subtypes
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}

                  <button onClick={addSubtype}>
                    Add Subtype <i className="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </form>
              </div>
            </div>

            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button className="save" onClick={handlePost}>
                Save
              </button>
            </div>
          </Prices>

          <Dialog
            open={open}
            keepMounted
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{"Please confirm"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {"Do you really want to remove the ticket ?"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteType} color="primary">
                {"Yes, delete"}
              </Button>
              <Button onClick={() => setOpen(false)} color="primary">
                {"Cancel"}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </section>
    </div>
  );
}

export default NewTickets;
